const inputFile = {
  init(): void {
    document.querySelectorAll<HTMLElement>('.input-file').forEach((target: HTMLElement) => {
      this.handleInputFile(target)
    })
  },

  handleInputFile(target): void {
    const el = {
      error: target.querySelector('.input-group__error'),
      filesList: target.querySelector('.input-file__files-list'),
      input: target.querySelector('.input-file__input'),
      trigger: target.querySelector('.input-file__trigger'),
    }

    const method = {
      init(): void {
        el.input.addEventListener('change', (event: InputEvent) => {
          event.preventDefault()
          const files = this.getFiles(event)
          const totalSize = files.reduce((acc, file) => acc + file.size / 1000000, 0)

          if (totalSize > 20) {
            this.removeFiles()
            target.classList.add('input-group--error')
            el.error.innerText = el.error.dataset.text
          } else {
            target.classList.remove('input-group--error')
            this.displayFiles(files)
          }
        })

        el.trigger.addEventListener('click', () => {
          target.classList.remove('input-group--error')
        })

        el.trigger.addEventListener('keydown', (event) => {
          if (event.key.match('Space') || event.key.match('Enter')) {
            el.input.focus()
            target.classList.remove('input-group--error')
          }
        })
      },

      removeFile(index: number): void {
        el.filesList.removeChild(el.filesList.children[index])
        const inputFiles: File[] = Array.from(el.input.files)

        inputFiles.splice(index, 1)

        // Update indexes of file items and remove buttons
        const fileItems = el.filesList.querySelectorAll('.input-file__file-item')
        const removeButtons = el.filesList.querySelectorAll('.input-file__remove-button')

        fileItems.forEach((fileItem, i) => {
          fileItem.dataset.index = i.toString()
          removeButtons[i].dataset.index = i.toString()

          // Update click event listener for each remove button
          removeButtons[i].removeEventListener('click', removeButtonClickHandler)
          removeButtons[i].addEventListener('click', removeButtonClickHandler)
        })

        // This doesn't work, workaround below
        // el.input.files = new FileList(inputFiles)

        // Workaround to create a new FileList object
        const newFileList = new DataTransfer()
        inputFiles.forEach((file: any) => {
          newFileList.items.add(file)
        })

        el.input.files = newFileList.files

        method.displayFiles(inputFiles)

        if (el.filesList.children.length < 1) {
          method.removeFiles()
        }

        function removeButtonClickHandler(event) {
          const indexToRemove: number = Number.parseInt(event.target.dataset.index)
          method.removeFile(indexToRemove)
        }
      },

      removeFiles(): void {
        el.filesList.classList.add('input-file__files-list--hidden')
        el.input.value = null
        el.filesList.innerHTML = ''
      },

      displayFiles(files: File[]): void {
        el.filesList.classList.remove('input-file__files-list--hidden')
        el.filesList.innerHTML = ''

        files.forEach((file, index) => {
          el.filesList.insertAdjacentHTML(
            'beforeend',
            `
              <div class='input-file__file-item' data-index='${index}'>
                <p class='body2'>${file.name}</p>
                <button class='button button--secondary button--square button--small input-file__remove-button' title='${el.input.dataset.textRemove}'>${el.input.dataset.textRemove}</button>
              </div>
            `
          )

          target.querySelector(`.input-file__file-item[data-index='${index}'] .input-file__remove-button`).addEventListener('click', () => {
            method.removeFile(index)
          })
        })
      },

      getFiles(event: InputEvent): File[] {
        const fileList = (event.target as HTMLInputElement).files
        if (!fileList || fileList.length === 0) {
          return []
        }
        return Array.from(fileList)
      },
    }

    method.init()
  },
}

export default inputFile
